import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ALERT } from "../../../store/actions/actionTypes";
import {
  adminDashboard,
  adminLogin,
} from "../../../store/actions/adminActions/adminAuth";

export default function Login(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { admin } = useSelector((state) => state);
  const { adminAuth } = admin;

  useEffect(() => {
    adminAuth.isAuth &&
      history.push(props.location.state?.from.pathname || "/admin/dashboard");
  }, [adminAuth.isAuth]);

  useEffect(() => {
    dispatch(adminDashboard());
  }, []);

  const [data, setData] = useState({ email: "", password: "", user_type: "1" });
  const { email, password, user_type } = data;
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(adminLogin(data));
    dispatch({
      type: ALERT,
      payload: { loading: true },
    });
  };
  return (
    <>
      <div class="sc-VigVT kCeVIa sc-gZMcBi jxPJzF"></div>
      <section class="logindesign">
        <div class="container">
          <div class="Formboxlogin">
            <div class="innerForm">
              <div class="Login-header">Login to your account</div> 
              <form onSubmit={handleSubmit}>
                <div class="telBoxform">
                  <div class="boxlabel">
                    <p>Login For</p>
                    <label class="Radioc">
                      Admin
                      <input
                        type="radio"
                        checked={user_type == "1"}
                        name="user_type"
                        value="1"
                        onChange={handleChange}
                      />
                      <span class="checC"></span>
                    </label>
                    <label class="Radioc">
                      Council
                      <input
                        type="radio"
                        name="user_type"
                        value="0"
                        checked={user_type == "0"}
                        onChange={handleChange}
                      />
                      <span class="checC"></span>
                    </label>
                    <label class="Radioc">
                      Faculty
                      <input
                        type="radio"
                        name="user_type"
                        value="6"
                        checked={user_type == "6"}
                        onChange={handleChange}
                      />
                      <span class="checC"></span>
                    </label>
                    {/* <label class="Radioc">
                        Member
                      <input
                        type="radio"
                        name="user_type"
                        value="0"
                        checked={user_type == "1"}
                        onChange={handleChange}
                      />
                      <span class="checC"></span>
                    </label> */}
                  </div>

                  <div class="formBox2">
                    <input
                      type="text"
                      placeholder="Enter UserName*"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      class="form-control"
                      required
                    />
                  </div>

                  <div class="formBox2">
                    <input
                      type="password"
                      placeholder="Password*"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="buttonSub">
                  <button class="btn btn-continues" type="submit">
                    Login
                  </button>
                </div>
              </form>
              <div class="Termslink mt-4">
                Forgot your password? <a href="#">Reset here</a>
              </div>
              <div class="My-help">
                Have trouble logging in? <span>Get help</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
